import { Icon } from 'components/Icon';

import { ArrowLinkIconContainer } from './ArrowLink.styled';
import { Link, LinkProps } from './Link';

export function ArrowLink({
  open,
  children,
  ...props
}: LinkProps & { open?: boolean }) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Link {...props}>
      {children}

      <ArrowLinkIconContainer>
        <Icon name={open ? 'chevron-up' : 'chevron-down'} size={24} />
      </ArrowLinkIconContainer>
    </Link>
  );
}
